import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

export default function Terms() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Términos y Condiciones | AULA K9",
    "description": "Términos y condiciones de uso de los servicios de formación de AULA K9 - Don Bandi El Taller de Pensar",
    "publisher": {
      "@type": "Organization",
      "name": "AULA K9 - Don Bandi El Taller de Pensar"
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Términos y Condiciones | AULA K9 - Don Bandi El Taller de Pensar"
        description="Condiciones generales de uso y contratación de los servicios de formación de AULA K9 - Don Bandi El Taller de Pensar. Información sobre certificación oficial, duración del curso, evaluaciones, protección de datos y normativa de bienestar animal."
        keywords="términos condiciones, normativa AULA K9, certificación oficial, protección datos, bienestar animal, condiciones contratación"
        canonical="/terminos"
        schema={schema}
      />
      <Header />
      <main>
        <section className="bg-gradient-to-br from-cyan-400 to-cyan-600 text-white py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="text-5xl font-bold mb-6">
                Términos y Condiciones
              </h1>
              <p className="text-xl text-cyan-50 leading-relaxed">
                Condiciones generales de uso y contratación de los servicios de formación de Aula K9 Arete Can
              </p>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">1. Identificación y Datos del Prestador de Servicios</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Denominación:</strong> Aula K9 Arete Can - El Taller de Pensar Don Bandi<br />
                <strong>Actividad:</strong> Formación online en adiestramiento canino y educación canina<br />
                <strong>Ubicación:</strong> Comunidad Foral de Navarra, España<br />
                <strong>Contacto:</strong> +34 722 131 257 | info@aulak9aretecan.com
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">2. Objeto y Ámbito de Aplicación</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Los presentes términos y condiciones regulan el acceso y uso de los servicios de formación online ofrecidos por Aula K9 Arete Can, incluyendo el acceso al campus virtual, materiales didácticos, evaluaciones y certificación oficial según el Real Decreto 545/2023.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                El uso de nuestros servicios implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en estos términos y condiciones.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">3. Certificación Oficial</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Nuestros programas formativos están diseñados para preparar a los alumnos conforme al <strong>Real Decreto 545/2023</strong> sobre Adiestramiento de Base y Educación Canina:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li><strong>Real Decreto 545/2023</strong></li>
                <li><strong>Nivel de cualificación:</strong> 2</li>
                <li><strong>Unidad de competencia:</strong> SEA531_2</li>
                <li><strong>Nombre:</strong> Adiestramiento de base y educación canina</li>
              </ul>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Importante sobre la certificación:</strong>
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Al finalizar la formación con éxito, Aula K9 Arete Can emitirá un <strong>certificado de aprovechamiento</strong> que acredita que el alumno ha completado satisfactoriamente el programa formativo ajustado al Real Decreto 545/2023.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Este certificado NO es un Certificado de Profesionalidad oficial.</strong> El Certificado de Profesionalidad es un título oficial emitido por el Servicio Público de Empleo Estatal (SEPE) o las administraciones autonómicas competentes.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Si el alumno desea obtener el <strong>Certificado de Profesionalidad oficial</strong>, deberá solicitarlo a través de los canales oficiales correspondientes. Aula K9 Arete Can ofrece <strong>asesoramiento y ayuda en todo el proceso de solicitud</strong> del certificado oficial para aquellos alumnos que lo requieran.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">4. Contenido del Programa Formativo</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                El programa incluye los siguientes módulos formativos:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li><strong>1741_2:</strong> Adiestramiento con técnicas de aprendizaje</li>
                <li><strong>1742_2:</strong> Modificación de conductas no deseadas</li>
                <li><strong>1743_2:</strong> Cuidados higiénicos básicos</li>
                <li><strong>1744_2:</strong> Primeros auxilios al animal</li>
                <li>Conocimiento de riesgos laborales y bienestar animal</li>
              </ul>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">5. Duración y Acceso al Curso</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Duración total:</strong> 6 meses desde la fecha de inscripción<br />
                <strong>Acceso al campus:</strong> 24 horas al día, 7 días a la semana durante todo el periodo formativo<br />
                <strong>Modalidad:</strong> 100% online con tutorías programadas
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Importante:</strong> Al finalizar los 6 meses de formación, la aplicación quedará bloqueada automáticamente. Solo permanecerá accesible la información esencial del curso. Las tutorías, materiales adicionales y contenido interactivo dejarán de estar disponibles.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Si el alumno desea continuar su formación o repasar contenidos específicos, podrá solicitar acceso nuevamente a las unidades de competencia que necesite, con las condiciones económicas vigentes en ese momento.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">6. Tutorías y Soporte Académico</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Horario de tutorías en directo:</strong> Sábados de 10:00 a 12:00 horas<br />
                <strong>Envío de dudas y consultas:</strong> De domingo a jueves<br />
                <strong>Tiempo de respuesta:</strong> Las dudas enviadas durante la semana serán resueltas en la tutoría del sábado siguiente
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Los alumnos tendrán acceso a tutores profesionales certificados en conducta animal durante todo el periodo formativo.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">7. Sistema de Evaluación y Exámenes</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Cada módulo formativo incluye un cuestionario de evaluación con las siguientes características:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li><strong>Número de preguntas:</strong> 25 preguntas por módulo</li>
                <li><strong>Formato:</strong> 3 opciones de respuesta, solo una correcta</li>
                <li><strong>Intentos permitidos:</strong> 2 intentos por examen</li>
                <li><strong>Nota mínima para aprobar:</strong> 20 respuestas correctas (80%)</li>
                <li><strong>Bloqueo:</strong> Tras el segundo intento fallido, el examen se bloqueará</li>
              </ul>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Datos personales en exámenes:</strong> El alumno deberá rellenar sus datos personales completos antes de realizar cada examen. Los resultados quedarán registrados en el sistema para su posterior certificación.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                En caso de bloqueo por dos intentos fallidos, el alumno deberá contactar con el equipo docente para valorar opciones de recuperación.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">8. Inscripción y Proceso de Matriculación</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Para formalizar la inscripción, el alumno deberá:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li>Completar el formulario de registro con datos personales veraces y actualizados</li>
                <li>Aceptar expresamente estos términos y condiciones</li>
                <li>Realizar el pago correspondiente a través de la pasarela de pago segura</li>
                <li>Recibir confirmación de matrícula por correo electrónico</li>
              </ul>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">9. Precios y Formas de Pago</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Los precios de los cursos se encuentran publicados en la web y pueden estar sujetos a promociones temporales. El pago se realizará a través de pasarela de pago segura, aceptando las principales tarjetas de crédito y débito.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Una vez realizado el pago, el alumno recibirá factura electrónica y acceso inmediato al campus virtual.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">10. Derecho de Desistimiento</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Conforme a la legislación española sobre protección de consumidores y usuarios, el alumno dispone de un plazo de <strong>14 días naturales</strong> desde la fecha de contratación para ejercer su derecho de desistimiento sin necesidad de justificación.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Para ejercer este derecho, el alumno deberá notificarlo por escrito a través del correo electrónico info@aulak9aretecan.com. Se procederá a la devolución íntegra del importe abonado en un plazo máximo de 14 días desde la recepción de la solicitud.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">11. Propiedad Intelectual</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Todos los contenidos del campus virtual (textos, imágenes, vídeos, fotografías, material didáctico, etc.) son propiedad de Aula K9 Arete Can o de terceros que han autorizado su uso.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Queda expresamente prohibida la reproducción, distribución, comunicación pública o transformación de dichos contenidos sin autorización expresa y por escrito del titular de los derechos.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">12. Protección de Datos Personales</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Los datos personales facilitados por los alumnos serán tratados conforme al Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Los datos serán utilizados exclusivamente para la gestión académica, comunicaciones relacionadas con el curso y emisión de certificados. El alumno podrá ejercer sus derechos de acceso, rectificación, supresión, limitación, portabilidad y oposición contactando con info@aulak9aretecan.com.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">13. Obligaciones del Alumno</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                El alumno se compromete a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li>Facilitar información veraz y actualizada en el proceso de registro</li>
                <li>Mantener la confidencialidad de sus credenciales de acceso</li>
                <li>Hacer un uso responsable y ético del campus virtual</li>
                <li>No compartir, reproducir o distribuir los contenidos del curso</li>
                <li>Respetar los derechos de propiedad intelectual</li>
                <li>Cumplir con la normativa vigente en materia de bienestar animal</li>
              </ul>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">14. Normativa de Bienestar Animal</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Todos nuestros programas formativos se desarrollan en cumplimiento estricto de la <strong>normativa vigente de la Comunidad Foral de Navarra</strong> en materia de protección y bienestar animal.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Los profesionales formados en Aula K9 Arete Can trabajarán siempre bajo los principios de respeto, empatía y trato ético hacia los animales, aplicando métodos basados en el refuerzo positivo y el bienestar animal.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">15. Responsabilidad y Limitaciones</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Aula K9 Arete Can no se hace responsable de:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-6 space-y-2">
                <li>Interrupciones técnicas o fallos en la conexión a internet del alumno</li>
                <li>Uso indebido de las credenciales de acceso por parte del alumno</li>
                <li>Daños derivados del mal uso de los conocimientos adquiridos</li>
                <li>Resultados profesionales posteriores a la finalización del curso</li>
              </ul>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">16. Modificaciones</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Aula K9 Arete Can se reserva el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones serán comunicadas a los alumnos con antelación suficiente y publicadas en la web.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">17. Legislación Aplicable y Jurisdicción</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Estos términos y condiciones se rigen por la legislación española. Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales de la Comunidad Foral de Navarra, renunciando expresamente a cualquier otro fuero que pudiera corresponderles.
              </p>

              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">18. Contacto</h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Para cualquier consulta relacionada con estos términos y condiciones, puede contactar con nosotros:
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong>Email:</strong> info@aulak9aretecan.com<br />
                <strong>Teléfono:</strong> +34 722 131 257<br />
                <strong>Horario de atención:</strong> Sábados de 10:00 a 12:00 horas
              </p>

              <div className="bg-cyan-50 border-l-4 border-cyan-500 p-6 mt-12">
                <p className="text-gray-800 font-semibold mb-2">
                  Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
                </p>
                <p className="text-gray-700 text-sm">
                  Al utilizar nuestros servicios, confirmas que has leído, comprendido y aceptado estos términos y condiciones en su totalidad.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
